import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = { class: "text-xs" }

import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout';
import { usePageStore } from '@/store';
import OktaLayout from '../OktaLayout/OktaLayout.vue';
import ContactJeopardy from './ContactJeopardy.vue';
import { RegistrationState } from '@/interfaces/pages/registration.interface';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactJeopardyPage',
  props: {
    fields: {},
    rendering: {},
    state: {},
    isLockedOut: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const dataTestId = usePageStore().dataTestId(props.rendering);

// ----------------------------------------------------------------------------------
// Functions
// ----------------------------------------------------------------------------------

function handleBackClick() {
  if (window && props.fields.ContactJeopardyBackToLink?.value?.href) {
    window.location.href = props.fields.ContactJeopardyBackToLink.value.href;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OktaLayout, null, {
    body: _withCtx(() => [
      _createElementVNode("div", { "data-test-id": _unref(dataTestId) }, [
        _createVNode(ContactJeopardy, _mergeProps(props, { onBackClicked: handleBackClick }), null, 16)
      ], 8, _hoisted_1)
    ]),
    disclaimer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(RichText), {
          field: _ctx.fields.Disclaimer
        }, null, 8, ["field"])
      ])
    ]),
    _: 1
  }))
}
}

})